module.exports = __webpack_public_path__ + "static/media/image13.e9cccde1.png";